import CheckBox from "@weave-design/checkbox";
import { PropertyEditor } from "./propertyEditor";
import { checkBoxStyles } from "./weaveDesignCheckboxStyle";
import "./inputs.css";
import "./booleanPropertyEditor.css";

type Props = {
    value: boolean;
    title: string;
    disabled?: boolean;
    onChange: (value: boolean) => void;
};

export const BooleanPropertyEditor = ({ title, value, disabled, onChange }: Props) => {
    return (
        <PropertyEditor title={title} className="boolean-property-editor">
            <CheckBox checked={value} onChange={onChange} disabled={!!disabled} stylesheet={checkBoxStyles} />
        </PropertyEditor>
    );
};
